let css = require('./required-field-mapping.css');
const accountUi = require('../../../../../../packages/account-ui');
const SCHEMES = require('../../../../../../helpers/scheme');
const signals = require('../../../../../../signals/bitrix');
const utils = require('../../../../../../signals/utils');
const accountUiSignal = require('../../../../../../signals/accountUi');

class RequiredMapping {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }
}

module.exports = {
    constructor: RequiredMapping,
    children: [
        {
            name: 'required-field-value',
            component: accountUi.Text,
            props: {
                signals: { inputText: signals.inputTextWithValidateMapping,
                    blurText: signals.blurTextWithValidateMapping },
                position: 'leftToRight',
                placeholder: 'Введите значение...'
            },
            watcher: (attributes) => ({
                value: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields',
                    attributes['cat-field'], 'value']
            })
        },
        {
            name: 'required-field-value-number',
            component: accountUi.Text,
            props: {
                signals: { inputText: signals.inputTextWithValidateMapping,
                    blurText: signals.blurTextWithValidateMapping },
                position: 'leftToRight',
                placeholder: 'Введите значение...',
                scheme: SCHEMES.numberOrEmpty
            },
            watcher: (attributes) => ({
                value: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields',
                    attributes['cat-field'], 'value'],
                error: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields',
                    attributes['cat-field'], 'error']
            })
        },
        {
            name: 'checkbox',
            component: accountUi.Checkbox,
            props: {
                signal: signals.setBitrixRequiredFieldValue
            },
            watcher: (attributes) => ({
                value: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields',
                    attributes['cat-path'], 'value']
            })
        },
        {
            name: 'select',
            component: accountUi.Select,
            props: {
                signalOnSelect: signals.selectHermesLeadRequiredValue,
                signalOnToggle: utils.togglePopupFromArgs
            },
            watcher: (attributes) => ({
                options: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields',
                    attributes['cat-field'], 'enumValues'],
                isDisable: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields',
                    attributes['cat-field'], 'isDisable'],
                isOpen: ['account', 'popups', 'bitrixExportLeads', 'requiredFields', attributes['cat-field'],
                    'isOpen'],
                isError: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields',
                    attributes['cat-field'], 'isError']
            })
        },
        {
            name: 'datepicker',
            component: accountUi.Datepicker,
            props: {
                scrollType: 'month',
                toggleDropdown: accountUiSignal.togglePopup,
                selectDate: signals.setDate(['account', 'orders', 'currentOrder', 'bitrixExportLeads',
                    'requiredFields']),
                clearInput: signals.unsetDate(['account', 'orders', 'currentOrder', 'bitrixExportLeads',
                    'requiredFields']),
                scrollPage: accountUiSignal.scrollPageDatepickerBase(['account', 'orders', 'currentOrder',
                    'bitrixExportLeads', 'requiredFields'])
            },
            watcher: (attributes) => ({
                id: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields',
                    attributes['cat-id'], 'datepicker', 'id'],
                mod: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields',
                    attributes['cat-id'], 'datepicker', 'mod'],
                withInputs: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields',
                    attributes['cat-id'], 'datepicker', 'withInputs'],
                withoutButton: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields',
                    attributes['cat-id'], 'datepicker', 'withoutButton'],
                selectedDate: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields',
                    attributes['cat-id'], 'datepicker', 'selectedDate'],
                calendars: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields',
                    attributes['cat-id'], 'datepicker', 'calendars'],
                range: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields',
                    attributes['cat-id'], 'datepicker', 'range'],
                availableRange: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields',
                    attributes['cat-id'], 'datepicker', 'availableRange'],
                title: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields',
                    attributes['cat-id'], 'datepicker', 'title'],
                isOpen: ['account', 'popups', 'bitrixExportLeads', 'requiredFields', attributes['cat-id'], 'isOpen'],
                isDisabled: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'computed', 'requiredFields',
                    attributes['cat-id'], 'datepicker', 'isDisabled']
            })
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/bitrix-export-leads/required-fields-mapping/index.js